 
import AjaxService from '../Ajax/index.jsx';


var TaxonomyTerms = function(term) {
  this.term = term;

  this._showLocked = true;
  this._changeListeners = [];
};
TaxonomyTerms.prototype.actionName = 'theme:taxonomy-terms-feed';
TaxonomyTerms.prototype.addChangeListener = function(callback) {
  this._changeListeners.push(callback);
};
TaxonomyTerms.prototype.removeChangeListener = function(callback) {
  for (var i = 0; i < this._changeListeners.length; i++) {
    if (this._changeListeners[i] == callback) {
      this._changeListeners.splice(i, 1);
      break;
    }
  }
};
TaxonomyTerms.prototype.showLocked = function(showLocked) {
  this._showLocked = Boolean(showLocked);

  // notify the listeners that things have changed.
  for (var i = 0; i < this._changeListeners.length; i++) {
    this._changeListeners[i]();
  }
};
TaxonomyTerms.prototype.fetchPage = function(page) {
  var data = {
    page: page,
    term: this.term,
    'show-locked': this._showLocked ? '1' : '0'
  };


  return AjaxService.fetch(this.actionName, data)
    .then(this.handleResponse);
};
TaxonomyTerms.prototype.handleResponse = function(response) {
  if (response) {
    return response;
  } else {
    return [];
  }
};


export default TaxonomyTerms;
